import { Component, Inject } from '@angular/core';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';

@Component({
    selector: 'app-modal-error',
    templateUrl: './modal-error.component.html',
    styleUrls: ['./modal-error.component.scss'],
    standalone: false
})
export class ModalErrorComponent  {
  constructor(@Inject(NX_MODAL_DATA) public data: any) {}

}
